<ng-template #infoDiv let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <i class="fas fa-info-circle fa-2x infoIcon"></i>
        <h4 id="alert-modal-title" class="modal-title infoTittle">{{'common.info' | translate}}</h4>
        <button type="button" class="close" (click)="hidenInfo()" title="{{'common.close' | translate}}" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div id="alert-modal-body" class="modal-body">
        <p>{{info.infoMessage | translate}}</p>
        <ul class="list-group" *ngIf="info.messages !== undefined && info.messages !== null && info.messages.length !== 0">
          <li class="list-group-item" *ngFor="let cause of info.messages">{{cause | translate}}</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-user btn-block" (click)="hidenInfo()">{{'common.close' | translate}}</button>
      </div>
    </div>
</ng-template>